import React from 'react';
import BaseSelect from './_internal/BaseSelect';

const Select = React.forwardRef((props, ref) => <BaseSelect {...props} ref={ref} />);

export default React.memo(Select);
